import { render, staticRenderFns } from "./AccountStatementModal.vue?vue&type=template&id=d65aabcc"
import script from "./AccountStatementModal.vue?vue&type=script&lang=js"
export * from "./AccountStatementModal.vue?vue&type=script&lang=js"
import style0 from "./AccountStatementModal.vue?vue&type=style&index=0&id=d65aabcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports